import React, { Suspense, lazy, useEffect, useState } from 'react';

const Palette = lazy(() => import('./Palette'));

/**
 * Cmd+K command palette with blog/project search, navigation, and actions.
 * Mounts globally via gatsby-browser wrapRootElement. This shell only
 * listens for the shortcut; the dialog (cmdk + search index) loads on first
 * open.
 */
export const CommandPalette: React.FC = () => {
  const [open, setOpen] = useState(false);

  // Toggle on Cmd+K / Ctrl+K
  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.key === 'k' && (e.metaKey || e.ctrlKey)) {
        e.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    const onOpenRequest = () => setOpen(true);
    document.addEventListener('keydown', onKeyDown);
    document.addEventListener('open-command-palette', onOpenRequest);
    return () => {
      document.removeEventListener('keydown', onKeyDown);
      document.removeEventListener('open-command-palette', onOpenRequest);
    };
  }, []);

  if (!open) return null;

  return (
    <Suspense fallback={null}>
      <Palette onClose={() => setOpen(false)} />
    </Suspense>
  );
};

export default CommandPalette;
